/** @return {object} - get product id */
const getProductId = state => {
  return state.appProduct.id;
};

/** @return {object} - get Product Name */
const getProductName = state => {
  return state.appProduct.name;
};

/** @return {object} - get Product Name */
const getProductPresentation = state => {
  return {
    name: state.appProduct.name,
    sku: state.appProduct.sku,
    shortDescription: state.appProduct.shortDescription,
    baRefConstructeur: state.appProduct.baRefConstructeur,
  };
};

/** @return {object} - get product legend */
const getProductLegend = state => {
  return state.appProduct.legend;
};

/** @return {string} - get product thumbnail */
const getProductThumbnail = state => {
  return state.appProduct.thumbnail;
};

/** @return {object} - get product dimenssions */
const getProductDescription = state => {
  return state.appProduct.description;
};

/** @return {object} - get product caracteristics */
const getProductCaracteristics = state => {
  return state.appProduct.technicalCharacteristics;
};

/** @return {object} - get product gallery */
const getProductGallery = state => {
  return state.appProduct.gallery;
};
/** @return {object} - get product videos */
const getProductVideos = state => {
  return state.appProduct.videos;
};

/** @return {object} - get current product delivery */
const getProductShippingMethods = state => {
  return state.appProduct.shippingMethods;
};

const getShippingMethodSelectedSpecialPrice = state => {
  return state.appProduct.billInfo.currentShippingMethodPrice.specialPrice;
}

/** @return {array} - get product options */
const getProductOptions = state => {
  return state.appProduct.options;
};

const getPacType = state => {
  return state.pac_type;
}

/** @return {array} - get product options */
const getProductEssentialsOptions = state => {
    return state.appProduct.essentialsOptions;
};

/** @return {object} - get product shippingInfo */
const getProductShippingInfo = state => {
  return state.appProduct.shippingInfo;
};

/** @return {object} - get product notice */
const getProductNotice = state => {
  return { notice: state.appProduct.notice, noticeCount: state.appProduct.noticeCount };
};

/** @return {object} - get product flashSell */
const getProductFlashSell = state => {
  return state.appProduct.flashSell;
};

/** @return {object} - get product bill info */
const getProductBillInfo = state => {
  return state.appProduct.billInfo;
};

/** @return {object} - get product bill info */
const getProductCartUrl = state => {
  return state.appProduct.cartUrl;
};

/** @return {object} - get product TVA by selected delivery */
const getProductTVAForCurrentDelivery = state => {
  return state.appProduct.billInfo.tva;
};

/** @return {object} - get product original TVA */
const getProductOriginalTVA = state => {
  return state.appProduct.billInfo.originalTva;
};

/** @return {object} - get product Schedule */
const getProductSchedule = state => {
  return state.appProduct.billInfo.schedule;
};

/** @return {object} - theck if product can be add to comparator */
const isProductCanBeAddToComparator = state => {
  return state.appProduct.canAddToComparator;
};

/** @return {object} - theck if product is in comparator */
const isProductInComparator = state => {
  return state.appProduct.isInComparator;
};
/** @return {object} - theck if product is in comparator */
const isProductTaxReducible = state => {
  return state.appProduct.isTaxReducible;
};
/** @return {object} - theck if product is in comparator */
const getProductReducedTaxRate = state => {
  return state.appProduct.reducedTaxRate;
};
/** @return {object} - theck if product is in comparator */
const getProductPriceInfo = state => {
  return state.appProduct.priceInfo;
};
/** @return {object} - renting price */
const getProductRentingPrice = state => {
  return state.renting_price;
};
/** @return {object} - renting price */
const getProductFinancingPrice = state => {
  return state.financing_price;
};
/** @return {object} - available for renting */
const getProductAvailableForRenting = state => {
  return state.is_rentable;
};
/** @return {object} - available for renting */
const getProductAvailableForFinancing = state => {
  return state.is_financeable;
};
/** @return {object} - available for renting */
const getProductIsRetailable = state => {
  return state.is_retailable;
};
/** @return {object} - available for renting */
const getProductExtendedWarranty = state => {
  return state.mcp_extended_warranty;
};

/** @return {object} - additional product */
const getProductAdditionalProduct = state => {
  return state.additional_product;
};

// ---- RELATED

/** @return {object} -related products of currentProduct */
const getProductsRelated = state => {
  return state.appProduct.productsRelated;
};

/** @return {object} -related products of currentProduct */
const getProductBlocks = state => {
  return state.appProduct.productBlocks;
};

/** @return {object} - get ProductInstallation */
const getProductInstallation = state => {
  return state.appProduct.getProductInstallation;
};

/** @return {object} -related products of currentProduct */
const getProductReviews = state => {
  return state.appProduct.productReviews;
};

/** @return {object} -related products of currentProduct */
const getProductReviewsAverage = state => {
  return state.appProduct.productReviewsAverage;
};

/** @return {object} -related products of currentProduct */
const getPushCom = state => {
    return {pushCom: state.appProduct.pushCom, pushComUrl: state.appProduct.pushComUrl};
}

/** @return {object} - get CategoryId */
const getCategoryId = state => {
  return state.appProduct.getCategoryId;
};

/** @return {object} - get ConfigQuestions */
const getConfigQuestions = state => {
  return state.appProduct.configQuestions;
};

/** @return {object} - get SelectedMonthsRenting */
const getProductRentingRelatedProducts = state => {
    return state.appProduct.renting_related_products;
};

const getAppProductRateTaxDeliveryClassic = (state, rateTaxDeliveryClassic) => {
    return state.rate_tax_delivery_classic;
};

/** @return boolean - check if product is in Lead mode */
const isLead = state => {
  return state.is_lead;
};

/** @return boolean - check if product univers Heat Pump */
const isPac = state => {
  return state.is_pac;
};

/** @return string - current product url encoded in base64 */
const getMediaSocialShareLinks = state => {
  return state.appProduct.socialMediaShare;
}
/** @return {object} - get different tva profils*/
const getTvaProfils = state => {
  return state.tva_profils;
};

const getLeadType = state => {
  return state.appProduct.lead_type;
}

/** @return string - current product universe */
const getProductUniverse = state => {
  return state.mcp_universe;
}

const isAccessoryProduct = state => {
  return state.is_accessory_product;
}

const getIsRFIDCard = state => {
    return state.is_RFID_card;
}

/** @return array - */
const getProductBreadcrumbs = state => {
    return state.breadcrumbs;
}

/** @return boolean - is slots choice active */
const getProductSlotsChoiceActive = state => {
  return state.mcp_slots_choice_active;
};

/** @return boolean - is slots choice active */
const getProductFormStrapiId = state => {
  return state.mcp_form_strapi_id;
};

export default {
  getProductId,
  getProductLegend,
  getProductPresentation,
  getProductThumbnail,
  getProductDescription,
  getProductCaracteristics,
  getProductGallery,
  getProductVideos,
  getProductShippingMethods,
  getProductNotice,
  getProductFlashSell,
  getProductShippingInfo,
  getProductBillInfo,
  isProductCanBeAddToComparator,
  isProductInComparator,
  getProductsRelated,
  getProductOptions,
  getProductEssentialsOptions,
  getProductName,
  getProductTVAForCurrentDelivery,
  getProductOriginalTVA,
  isProductTaxReducible,
  getProductReducedTaxRate,
  getProductBlocks,
  getProductInstallation,
  getProductReviews,
  getProductReviewsAverage,
  getProductSchedule,
  getProductPriceInfo,
  getProductCartUrl,
  getPushCom,
  getCategoryId,
  getConfigQuestions,
  getProductAvailableForRenting,
  getProductAvailableForFinancing,
  getProductIsRetailable,
  getProductExtendedWarranty,
  getProductRentingPrice,
  getProductFinancingPrice,
  getProductAdditionalProduct,
  getProductRentingRelatedProducts,
  getAppProductRateTaxDeliveryClassic,
  isLead,
  isPac,
  getMediaSocialShareLinks,
  getTvaProfils,
  getLeadType,
  getProductUniverse,
  isAccessoryProduct,
  getIsRFIDCard,
  getProductBreadcrumbs,
  getShippingMethodSelectedSpecialPrice,
  getProductSlotsChoiceActive,
  getProductFormStrapiId,
  getPacType
};
